import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import SEOHead from "../components/SEOHead";

const TermsPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <SEOHead 
        title="Terms & Conditions"
        description="Terms and conditions for CNESS certification platform and services."
        url="/terms"
      />
      
      <Header />
      
      <main className="pt-24">
        <section className="py-16 bg-white">
          <div className="container mx-auto px-6">
            <div className="max-w-4xl mx-auto">
              <h1 className="text-4xl font-bold text-gray-900 mb-8">Terms & Conditions</h1>
              
              <div className="prose prose-lg max-w-none">
                <p className="text-lg text-gray-600 mb-8">
                  Last updated: {new Date().toLocaleDateString()}
                </p>

                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">1. Acceptance of Terms</h2>
                <p className="text-gray-700 mb-6">
                  By accessing and using the CNESS certification platform, you accept and agree to be bound by the terms and provision of this agreement.
                </p>

                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">2. Certification Services</h2>
                <p className="text-gray-700 mb-6">
                  CNESS provides conscious business certification services based on our 6 Pillars framework. All assessments are conducted by qualified reviewers according to established standards.
                </p>

                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">3. User Responsibilities</h2>
                <p className="text-gray-700 mb-6">
                  Organizations seeking certification must provide accurate information and evidence during the assessment process. Misrepresentation may result in certification denial or revocation.
                </p>

                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">4. Certification Validity</h2>
                <p className="text-gray-700 mb-6">
                  Certifications are valid for the period specified in your certification tier. Renewal requires re-assessment according to current standards.
                </p>

                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">5. Intellectual Property</h2>
                <p className="text-gray-700 mb-6">
                  The CNESS framework, badges, and related materials are proprietary to CNESS. Licensed use is granted to certified organizations for promotional purposes.
                </p>

                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">6. Limitation of Liability</h2>
                <p className="text-gray-700 mb-6">
                  CNESS provides certification services "as is" and makes no warranties regarding business outcomes resulting from certification.
                </p>

                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">7. Contact Information</h2>
                <p className="text-gray-700 mb-6">
                  For questions about these terms, please contact us at <a href="mailto:contact@cness.co" className="text-amber-600 hover:underline">contact@cness.co</a>.
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default TermsPage;